<template>
  <div style="display:inline-block;">
    <div :key="item.dataIndex">
      <a-popover placement="topLeft" arrow-point-at-center>
        <template slot="content" v-if="isEnbaleLanguage">
          <div style="width: 200px;" v-if="secondLanguage && secondLanguage.length">
            <a-row v-for="sItem in secondLanguage" :key="sItem.id">
              <a-col :span="8" style="text-align: right; font-weight: bold">{{ sItem.langType }}：</a-col>
              <a-col :span="16">{{ sItem.langText }}</a-col>
            </a-row>
          </div>
          <template v-else>{{ $t('tip.noData') }}</template>
        </template>
        <span @mouseenter="showPop">{{ text }}</span>
      </a-popover>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'mtcLangModule',
  props: {
    // 整条信息传入
    record: {
      type: Object,
      default: () => {
      }
    },
    // 当前字段信息
    item: {
      type: Object,
      default: () => {
      }
    },
    text: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      isShow: false,
      // 次语言列表
      secondLanguage: []
    }
  },
  computed: {
    ...mapGetters(['tableLangMap'])
  },
  methods: {
    isEnbaleLanguage(){
      return this.$getLanguageEnable()
    },
    showPop() {
      let field = this.item.dataIndex || this.item.key
      let key = `${this.record.id},${field}`
      this.secondLanguage = this.tableLangMap[ key ]
      // 子表从列表数据中取多语言
      if(!this.tableLangMap[ key ]) {
        this.secondLanguage = this.record.sysLanguageList
      }
    }
  }
}
</script>

<style>
</style>